
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');


/**
 * Charting
 */
require('chart.js');

/**
 * 
 * Data tables sorting
 * 
 */
require('datatables.net-bs4');
require('moment');
require('./datetime-moment.js');

//Supported table formats for data table sorting on date
$.fn.dataTable.moment('DD/MM/YY HH:mm');
$.fn.dataTable.moment('DD-MMM-YY'); // e.g. 01-May-20

/**
 * 
 * Feather Icons
 * 
 * 
 */
window.feather = require('feather-icons');

/**
 * 
 * Custom generic JS for the application
 * 
 * Needs to be inside a $(document).ready to make sure
 * everything is built before adding listeners and other things
 * to the DOM.
 * 
 * 
 * Initiall the tab control below was not firing until it was put inside
 * the ready funcion.
 * 
 * 
 */

$(document).ready(function () {

    // Handle checkbox groups where at least one is required
    (function () {
        const form = document.querySelector('#check-box-group');
        const checkboxes = form === null ? null : form.querySelectorAll('input[type=checkbox]');
        const checkboxLength = form === null ? 0 : checkboxes.length;
        const firstCheckbox = checkboxLength > 0 ? checkboxes[0] : null;

        function init() {
            if (firstCheckbox) {
                for (let i = 0; i < checkboxLength; i++) {
                    checkboxes[i].addEventListener('change', checkValidity);
                }

                checkValidity();
            }
        }

        function isChecked() {
            for (let i = 0; i < checkboxLength; i++) {
                if (checkboxes[i].checked) return true;
            }

            return false;
        }

        function checkValidity() {
            const errorMessage = !isChecked() ? 'At least one checkbox must be selected.' : '';
            firstCheckbox.setCustomValidity(errorMessage);
        }

        init();
    })();


    /**
     * 
     * Handle going to specific tabs on tabbed
     * pages.
     * 
     * Note: removed the follow from the loop in _tabs.blade.php to make the transition smoother
     * if left in it stops working because it needs to match up with whats in the panel.
     * 
     * Choosing in pane (_table_pane.blade.php) has been left in for future reference.
     * 
     *  From:
     *  <a class="nav-link {{  $loop->first ? 'active' : '' }}" id="pills-{{ $key }}-tab" data-toggle="pill" href="#pills-{{ $key }}" role="tab"
     * 
     *  To:
     * 
     * <a class="nav-link" id="pills-{{ $key }}-tab" data-toggle="pill" href="#pills-{{ $key }}" role="tab"
     * 
     * Also makes the code a bit more tidy.
     */



    (function () {
        if ($('#pills-tab').length) {
            var url = window.location.href;

            // If there is a # in the URL then got to the tab
            if (url.match('#')) {

                var activeTab = url.substring(url.indexOf("#") + 1);

                //If the is no # show then make sure the first tab is active
                $('#pills-tab a[href="#pills-' + activeTab + '"]').tab('show');
            }
            // No # so show the firts tab incase its not active
            else {
                $('#pills-tab li:first-child a').tab('show');
            }
        }
    })();

    /**
     * 
     * Handle back to top scolling
     * 
     */
    $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
            $('#back-to-top').fadeIn();

        } else {
            $('#back-to-top').fadeOut();
        }
    });

    // scroll body to 0px on click
    $('#back-to-top').click(function () {
        $('#back-to-top').tooltip('hide');
        $('body,html').animate({
            scrollTop: 0
        }, 800);
        return false;
    });

});





